import { useQuery } from '@gogame/query';

import { loadDimensions } from '../sources/creativesTracker';

import { dimensions } from './queryKeyFactory';

export const useLoadDimensions = (params) => {
  return useQuery(dimensions(params), (_, { signal }) => {
    return loadDimensions(params, { signal });
  });
};
